import { AccordionContext } from '@/components/blocks/SideBar';
import { facetNavigationAccordionSX } from '@/components/content/FacetNavigation/styles/accordion';
import { facetNavigationAccordionSummarySX } from '@/components/content/FacetNavigation/styles/accordionSummary';
import { useHelloRetailSearch } from '@/data/Content/HelloRetailSearch';
import { useLocalization } from '@/data/Localization';
import { MAX_INITIAL_FILTER_SHOW_COUNT } from '@/data/constants/HelloretailSearch';
import { ContentContext } from '@/data/context/content';
import { useDeviceType } from '@/data/deviceDetection';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Grid,
	Stack,
	Typography,
} from '@mui/material';
import { FC, SyntheticEvent, useCallback, useContext, useState } from 'react';

export const FacetNavigationCategoryFacet: FC = () => {

	const productFilterNLS = useLocalization('ProductFilter');

	const {
		filterKeys,
		filterTitles,
		filters,
		handleFilterChange,
		filtersShowMore,
		toggleFacetShowMore,
		loading
	} = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;

	const { toggleOpen } = useContext(AccordionContext) as { toggleOpen: () => void };
	const { isMobile } = useDeviceType();
	const [activeFacetId, setActiveFacetId] = useState<string>(() => '');
	const handleAccordionChange = useCallback(
		(facetValue: string) => (_event: SyntheticEvent<Element, Event>, isExpanded: boolean) => {
			isMobile && setActiveFacetId(isExpanded ? facetValue : '');
		},
		[isMobile]
	);
	return (
		<>
			{filterKeys?.map((filterKey) => (
				filterKey.toLowerCase().toString() === 'hierarchies' && (
					<Accordion
						id={`productFilter-facet-${filterTitles[filterKey]}`}
						data-testid={`productFilter-facet-${filterTitles[filterKey]}`}
						defaultExpanded={!isMobile}
						key={filterTitles[filterKey]}
						expanded={!isMobile || activeFacetId === filterTitles[filterKey]}
						onChange={handleAccordionChange(filterTitles[filterKey])}
						square={true}
						sx={facetNavigationAccordionSX}
					>
						<AccordionSummary
							aria-controls={`${filterTitles[filterKey]}-content`}
							id={`${filterTitles[filterKey]}-header`}
							data-testid={`${filterTitles[filterKey]}-header`}
							sx={facetNavigationAccordionSummarySX}
							expandIcon={isMobile ? <ExpandMoreIcon /> : null}
						>
							<Typography variant="body2">
								{filterTitles[filterKey]}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Stack justifyContent="flex-start" alignItems="flex-start">
								<Grid container spacing={1}>
									{Array.isArray(filters[filterKey]) && filters[filterKey]?.map((filter: any, i) => {
										const filterTitle = (filter?.title as string)?.substring(0, filter?.title?.length-1);
										return ((filtersShowMore[filterKey] && i < MAX_INITIAL_FILTER_SHOW_COUNT) || !filtersShowMore[filterKey]) ?
											(
												<Grid item xs={12} key={i}>
													<Stack direction="row" alignItems="center" columnGap={2}>
														<FormGroup>
															<FormControlLabel
																control={
																	<Checkbox
																		disableRipple
																		sx={{ p: 0, cursor: loading ? 'wait' : 'pointer' }}
																		checked={filter?.selected}
																		onChange={(event, checked) => handleFilterChange(checked, filter?.query ?? '')}
																	/>
																}
																label={`${filterTitle} (${filter?.count ?? 0})`}
															/>
														</FormGroup>
													</Stack>
												</Grid>
											)
											: null
									})}
								</Grid>
								{filterKey in filtersShowMore ?
									<Button
										variant="inline"
										data-testid={`productFilter_${filterKey}_show_more`}
										id={`productFilter_${filterKey}_show_more`}
										onClick={() => toggleFacetShowMore(filterKey)}
										sx={{ mb: 1 }}
									>
										{filtersShowMore[filterKey]
											? productFilterNLS.Actions.showMore.t()
											: productFilterNLS.Actions.showLess.t()}
									</Button>
									: null
								}
							</Stack>
							{isMobile ?
								<Button
									variant="contained"
									sx={{ width: '100%', mt: 1 }}
									onClick={toggleOpen}
								>
									{productFilterNLS.Actions.ShowResults.t()}
								</Button>
								: null}
						</AccordionDetails>
					</Accordion>
				)
			))}
		</>
	);
};